import { render } from "./Assets.vue?vue&type=template&id=c571e686&scoped=true"
import script from "./Assets.vue?vue&type=script&lang=js"
export * from "./Assets.vue?vue&type=script&lang=js"

import "./Assets.vue?vue&type=style&index=0&id=c571e686&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c571e686"],['__file',"src/views/Assets.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c571e686"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c571e686', __exports__)) {
    api.reload('c571e686', __exports__)
  }
  
  module.hot.accept("./Assets.vue?vue&type=template&id=c571e686&scoped=true", () => {
    api.rerender('c571e686', render)
  })

}


export default __exports__